import LoginComp from '../component/login';

export default () => {
  return <LoginComp scene="retrieve-data" />;
};

export async function getServerSideProps() {
  return {
    props: {
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
    },
  };
}
